import { ReactNode, createContext, useContext } from 'react';

const FormNameContext = createContext<{ formName: string; isLoading: string; setLoading?: (value: string) => void }>(
  {} as any
);

export const useFormName = () => useContext(FormNameContext);

type FormNameProviderProps = {
  formName: string;
  isLoading?: string;
  setLoading?: (value: string) => void;
  children: ReactNode;
};

export const FormNameProvider = ({ formName, isLoading = '', setLoading, children }: FormNameProviderProps) => (
  <FormNameContext.Provider value={{ formName, isLoading, setLoading }}>{children}</FormNameContext.Provider>
);
